module.exports = __webpack_public_path__ + "media/public/img/icon-api-connected-76b4e2a3039430cb911943febb3207bd.png";